<ng-container *ngIf="profile$ | async as profile">
  <ng-container *ngIf="profile.isLoggedIn; else signInCommentary">
    <!-- Fund Commentary -->
    <div edsRow>
      <div edsCol>
        <!-- Title -->
        <div edsSubGridGap="sm" edsSubGrid="layout-1" edsSpacing="sm">
          <ng-container *ngIf="(showDefaultTitle$ | async) !== true">
            <ng-container
              *ngIf="
                (showQuaterlyDocsTitle$ | async) === true;
                else monthlyCommentaryCustomTitle
              "
            >
              <ng-container
                *ngIf="
                  quarterlyFundCommentaryDocuments$
                    | async as quarterlyFundCommentaryDocuments
                "
              >
                <ng-container
                  [ngTemplateOutlet]="customCommentaryTitle"
                  [ngTemplateOutletContext]="{
                    doc: {
                      title: commentaryTitle,
                      publicationDate: quarterlyFundCommentaryDocuments[0]
                        ?.publicationDate
                        ? quarterlyFundCommentaryDocuments[0]?.publicationDate
                        : ''
                    }
                  }"
                ></ng-container>
              </ng-container>
            </ng-container>
            <ng-template #monthlyCommentaryCustomTitle>
              <ng-container
                *ngIf="
                  monthlyFundCommentaryDocuments$
                    | async as monthlyFundCommentaryDocuments
                "
              >
                <ng-container
                  *ngIf="
                    monthlyFundCommentaryDocuments[0]?.publicationDate;
                    else monthlyCommentaryCustomTitleNonHistorical
                  "
                >
                  <ng-container
                    [ngTemplateOutlet]="customCommentaryTitle"
                    [ngTemplateOutletContext]="{
                      doc: {
                        title: monthlyCommentaryTitle,
                        publicationDate: monthlyFundCommentaryDocuments[0]
                          ?.publicationDate
                          ? monthlyFundCommentaryDocuments[0]?.publicationDate
                          : ''
                      }
                    }"
                  ></ng-container>
                </ng-container>
                <ng-template #monthlyCommentaryCustomTitleNonHistorical>
                  <ng-container
                    *ngIf="downloadDocument$ | async as downloadDocument"
                  >
                    <ng-container
                      [ngTemplateOutlet]="customCommentaryTitle"
                      [ngTemplateOutletContext]="{
                        doc: {
                          title: monthlyCommentaryTitle,
                          publicationDate: downloadDocument?.publicationDate
                            ? downloadDocument?.publicationDate
                            : ''
                        }
                      }"
                    ></ng-container>
                  </ng-container>
                </ng-template>
              </ng-container>
            </ng-template>
          </ng-container>
        </div>
        <div edsSubGridGap="lg" edsSubGrid="layout-1" edsSpacing="md">
          <ng-container
            *ngIf="fundCommentaryContent$ | async as fundCommentaryContent"
          >
            <ng-container *ngIf="fundCommentaryContent">
              <div>
                <!-- Title -->
                <eds-title
                  [title]="commentaryTitle + ' ' + publicationDate"
                  size="h5"
                  theme="basic"
                  [edsSpacing]="fullDescription ? 'md' : 'xs'"
                ></eds-title>
                <div class="ck-editor">
                  <p
                    *ngIf="!fullDescription"
                    edsSpacing="lg"
                    [innerHtml]="
                      fundCommentaryContent?.commentaryKeyPoints | safeHtml
                    "
                  ></p>
                  <ng-container *ngIf="fullDescription">
                    <div class="table-commentary">
                      <div
                        edsSpacing="md"
                        [innerHtml]="
                          fundCommentaryContent?.fullCommentary | safeHtml
                        "
                      ></div>
                    </div>
                  </ng-container>
                </div>
              </div>
            </ng-container>
          </ng-container>

          <div edsSubGrid="layout-1" edsSubGridGap="lg">
            <ng-container
              *ngIf="
                fundCommentaryDocuments$ | async as fundCommentaryDocuments
              "
            >
              <ng-container
                *ngIf="
                  quarterlyFundCommentaryDocuments$
                    | async as quarterlyFundCommentaryDocuments
                "
              >
                <ng-container
                  *ngIf="quarterlyFundCommentaryDocuments?.length > 0"
                >
                  <ng-container
                    [ngTemplateOutlet]="commentarySections"
                    [ngTemplateOutletContext]="{
                      docs: {
                        title: 'lit-commentary-quarterly',
                        commentary: quarterlyFundCommentaryDocuments
                      }
                    }"
                  >
                  </ng-container>
                </ng-container>
              </ng-container>
              <ng-container
                *ngIf="
                  monthlyFundCommentaryDocuments$
                    | async as monthlyFundCommentaryDocuments
                "
              >
                <ng-container
                  *ngIf="monthlyFundCommentaryDocuments?.length > 0"
                >
                  <ng-container
                    [ngTemplateOutlet]="commentarySections"
                    [ngTemplateOutletContext]="{
                      docs: {
                        title: 'lit-commentary-monthly',
                        commentary: monthlyFundCommentaryDocuments
                      }
                    }"
                  >
                  </ng-container>
                </ng-container>
              </ng-container>
            </ng-container>
          </div>
        </div>
        <div edsSpacing="lg" edsFlexbox>
          <ng-container
            *ngIf="{
              showFullDescription: !fullDescription,
              viewDocs: fundCommentaryDocContinueRead$ | async,
              viewContent: fundCommentaryContentContinueRead$ | async
            } as buttonState"
          >
            <button
              *ngIf="
                buttonState?.showFullDescription &&
                (buttonState?.viewDocs || buttonState?.viewContent)
              "
              (click)="continueReading()"
              edsButton="primary"
              size="compact"
            >
              <span *ngIf="buttonState?.viewContent !== true">{{
                "literature.view-more-docs" | translate
              }}</span>
              <span *ngIf="buttonState?.viewContent === true">{{
                "literature.lit-commentary-continue-reading" | translate
              }}</span>
            </button>
          </ng-container>
          <ng-container *ngIf="downloadDocument$ | async as downloadDocument">
            <a
              [noMargin]="true"
              target="_blank"
              [href]="downloadDocument?.downloadPdfUrl"
              [edsButton]="'secondary'"
              size="compact"
            >
              <span class="ft__btn__txt">{{
                "literature.download" | translate
              }}</span>
              <!--icon-->
              <eds-icon
                class="modal-close__icon"
                type="download"
                size="small"
                aria-hidden="true"
              ></eds-icon>
            </a>
          </ng-container>
        </div>
        <ng-container
          *ngIf="fundCommentaryContent$ | async as fundCommentaryContent"
        >
          <ng-container *ngIf="fundCommentaryContent">
            <div
              edsSubGridGap="lg"
              edsSubGrid="layout-1"
              edsSpacing="md"
              *ngIf="fullDescription"
            >
              <div>
                <eds-title
                  title="{{
                    'literature.lit-commentary-legal-info-title' | translate
                  }}"
                  size="h5"
                  edsSpacing="md"
                  theme="basic"
                >
                </eds-title>
                <div
                  class="ck-editor"
                  edsSpacing="md"
                  [innerHtml]="
                    fundCommentaryContent?.importantLegalInformation | safeHtml
                  "
                ></div>
              </div>
            </div>
          </ng-container>
        </ng-container>
      </div>
    </div>
    <!-- <eds-divider></eds-divider> -->
  </ng-container>
  <ng-template #signInCommentary>
    <div edsGrid>
      <div class="container--wide">
        <ft-sign-in
          [inputParameters]="{
            skin: 'Basic 2 Columns',
            legacy: false,
            signOut: false
          }"
        >
        </ft-sign-in>
      </div>
    </div>
  </ng-template>
</ng-container>

<ng-template let-commentaryDocs="docs" #commentarySections>
  <div edsSpacing="lg">
    <eds-title
      title="{{ 'literature.' + commentaryDocs?.title | translate }}"
      size="h6"
      theme="basic"
      edsSpacing="xs"
    ></eds-title>
    <ul edsList class="list--unstyled">
      <ng-container
        *ngFor="let document of commentaryDocs?.commentary; let i = index"
      >
        <li edsListItem>
          <ng-container *ngIf="fullDescription ? true : i < 4">
            <div edsFlexbox alignItems="center">
              <a
                edsLink
                target="_blank"
                [href]="document?.downloadPdfUrl"
                class="text-decoration-none"
              >
                <eds-icon
                  edsPadding
                  edsPaddingRight="md"
                  edsPaddingTop="md"
                  edsPaddingBottom="md"
                  type="pdf"
                  [addTitle]="'literature.pdf-icon' | translate"
                  size="large"
                ></eds-icon>

                {{ document.publicationDate }}
              </a>
            </div>
            <eds-divider></eds-divider>
          </ng-container>
        </li>
      </ng-container>
    </ul>
  </div>
</ng-template>
<ng-template let-document="doc" #customCommentaryTitle>
  <eds-title
    [title]="document.title + ' ' + document.publicationDate"
    size="h5"
    theme="basic"
    [edsSpacing]="fullDescription ? 'md' : 'xs'"
  ></eds-title>
</ng-template>
